"use client";



import Image from "next/image";

import Link from "@/components/ui/Link";

import { useRouter } from "next/navigation";

import { FaRegBookmark, FaRegCommentDots } from "react-icons/fa";

import { MessageIcon } from "../ui/message-icon";

import { FALLBACK_IMAGE } from '@/lib/constants';

import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";

import { getImageUrl, getTimeAgo, getSectionUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';



type FieldConfig = {

  hidden?: boolean;

  value?: string;

  customClass?: string;

};



type Props = {

  category?: FieldConfig;

  sectionUrl?: string;

  title?: FieldConfig;

  excerpt?: FieldConfig;

  timeAgo?: FieldConfig;

  imageSrc?: FieldConfig;

  slug?: string;

  imageMetadata?: ImageMetadata;

};



export default function VerticalBigImagecategoryNewsbgWhite({

  category = { hidden: false, value: "TAMIL NADU", customClass: "" },

  sectionUrl,

  title = { hidden: false, value: "ஹனி ட்ராப்பிங்: நவி மும்பையில் இருந்து 7 பேர் கொண்ட கும்பலை கோவை சைபர் கிரைம் போலீசார் கைது செய்தனர்", customClass: "" },

  excerpt = { hidden: false, value: "அவர்கள் அப்சல் ரசூல்மானால் பணியமர்த்தப்பட்டனர் மற்றும் நவி மும்பையில் உள்ள உல்வே, செக்டர் 19 இல் உள்ள ஒரு அடுக்குமாடி குடியிருப்பில் இயங்கி வந்தனர்.", customClass: "" },

  timeAgo = { hidden: false, value: "15 min ago", customClass: "" },

  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },

  slug,

  imageMetadata,

}: Props) {

  const router = useRouter();



  const categoryValue = category?.value || "";

  const titleValue = title?.value || "";

  const excerptValue = excerpt?.value || "";

  const timeAgoValue = getTimeAgo(timeAgo?.value);

  const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;

  const sectionUrlValue = getSectionUrl(sectionUrl);



  const handleCategoryClick = (e: React.MouseEvent) => {

    if (sectionUrlValue) {

      e.preventDefault();

      e.stopPropagation();

      router.push(sectionUrlValue);

    }

  };



  const content = (

    <article className="flex flex-col bg-transparent overflow-hidden p-4 gap-4">

      {/* IMAGE */}

      {!imageSrc?.hidden && (

        <div className={` ${imageSrc?.customClass || ""}`}>

          <div className="relative w-full aspect-[16/9] md:aspect-[16/7] overflow-hidden">

            <Image

              src={imageSrcValue}

              alt={titleValue}

              fill

              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px"

              className="object-cover w-full h-full"

              style={getFocusPointStyle(imageMetadata)}

              loading="lazy"

              placeholder="blur"

              blurDataURL={BLUR_PLACEHOLDER}

            />

          </div>

        </div>

      )}



      {/* CONTENT */}

      <div className="flex flex-col gap-2">

        {/* Category */}

        {/* {sectionUrl ? (

          <span

            className="text-14-tamil-600 text-FFFFFF tracking-wide uppercase hover:underline cursor-pointer"

            onClick={handleCategoryClick}

          >

            {category}

          </span>

        ) : (

          <div className="text-14-tamil-600 text-FFFFFF tracking-wide uppercase">

            {category}

          </div>

        )} */}



        {/* Title */}

        {!title?.hidden && (

 <h3 className={`text-FFFFFF text-24-tamil-700 md:text-16-tamil-700 leading-[1.4] min-h-[67px] ${title?.customClass || ""}`}>

            {titleValue}

          </h3>

        )}



        {/* Excerpt */}

        {!excerpt?.hidden && (

          <p className={`text-14-tamil-400 md:text-14-tamil-400 text-FFFFFF leading-[1.5] line-clamp-2 ${excerpt?.customClass || ""}`}>

            {excerptValue}

          </p>

        )}



        <div className="flex items-center justify-between gap-2">

          {!timeAgo?.hidden && (

            <span className={`text-12-tamil-500 text-FFFFFF ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>

          )}



          <div className="flex items-center gap-4">

          <MessageIcon

                id="small-image-news-vert-message-icon"

                variant='message-icon-4'

                slug={slug}

                category={BOOKMARK_CATEGORIES.NEWS}

                title={titleValue}

                thumbnailUrl={imageSrcValue}

                description={excerptValue}

                articleUrl={slug ? `/${slug}` : undefined}

              />

          </div>

        </div>

      </div>

    </article>

  );



  if (slug) {

    return (

      <Link href={`/${slug}`} className="block transition-opacity cursor-pointer">

        {content}

      </Link>

    );

  }



  return content;

}

